var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBriefcase = function SvgBriefcase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6 5c0-1.7 1.3-3 3-3h2c1.7 0 3 1.3 3 3v13H6V5zm2 0c0-.6.4-1 1-1h2c.6 0 1 .4 1 1v1H8V5z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 6c-.6 0-1 .4-1 1v10c0 .6.4 1 1 1h2V6H2zM18 6h-2v12h2c.6 0 1-.4 1-1V7c0-.6-.4-1-1-1z"
  })));
};
export default SvgBriefcase;